
export class FrequencyAnalyzer {
  public static async analyzeFile(
    ctx: AudioContext, 
    file: File, 
    cs: number, 
    ce: number, 
    onProg?: (p: number) => void
  ): Promise<number[]> {
    const ab = await file.arrayBuffer();
    const audioBuf = await ctx.decodeAudioData(ab);
    const data = audioBuf.getChannelData(0);
    const sliced = data.slice(Math.floor((cs / 100) * data.length), Math.floor((ce / 100) * data.length));
    const freqs: number[] = [];
    const chunks = 200;
    const size = Math.floor(sliced.length / chunks);
    
    for (let i = 0; i < chunks; i++) {
        const window = sliced.slice(i * size, i * size + 2048);
        const pitch = FrequencyAnalyzer.autoCorrelate(window, audioBuf.sampleRate);
        if (pitch > 50 && pitch < 3000) freqs.push(pitch);
        if (i % 20 === 0 && onProg) onProg(Math.floor((i / chunks) * 100));
    }
    if (onProg) onProg(100);
    return freqs;
  }

  private static autoCorrelate(buf: Float32Array, sr: number): number {
    let rms = 0; 
    for (let i = 0; i < buf.length; i++) rms += buf[i] * buf[i];
    if (Math.sqrt(rms / buf.length) < 0.01) return -1;
    
    let r1 = 0, r2 = buf.length - 1, thres = 0.2;
    for (let i = 0; i < buf.length / 2; i++) if (Math.abs(buf[i]) < thres) { r1 = i; break; }
    for (let i = 1; i < buf.length / 2; i++) if (Math.abs(buf[buf.length - i]) < thres) { r2 = buf.length - i; break; }
    
    const b = buf.slice(r1, r2); 
    if (b.length < 2) return -1;
    
    const c = new Float32Array(b.length).fill(0);
    for (let i = 0; i < b.length; i++) for (let j = 0; j < b.length - i; j++) c[i] = c[i] + b[j] * b[j + i];
    
    let d = 0; 
    while (d < b.length - 1 && c[d] > c[d + 1]) d++;
    
    let maxval = -1, maxpos = -1;
    for (let i = d; i < b.length; i++) {
      if (c[i] > maxval) {
        maxval = c[i];
        maxpos = i;
      }
    }
    
    let T0 = maxpos;
    if (T0 <= 0) return -1;
    
    // Parabolic interpolation for better precision
    let x1 = c[T0 - 1], x2 = c[T0], x3 = c[T0 + 1];
    let a = (x1 + x3 - 2 * x2) / 2;
    let bCoef = (x3 - x1) / 2;
    if (a) T0 = T0 - bCoef / (2 * a);

    return sr / T0;
  }
}
